/* Founding Drop gallery interaction shared by block-backed and native Shopify media. */
(function () {
  'use strict';
  if (window.KorenaProductGallery) return;
  function thumbs(gallery) { return Array.from(gallery.querySelectorAll('.gthumb')); }
  function select(gallery, target, scroll, imageAlt) {
    if (!gallery || !target) return;
    var items = thumbs(gallery), id = target.dataset.kpThumb;
    items.forEach(function (item) {
      var active = item === target;
      item.dataset.active = String(active);
      if (item.hasAttribute('aria-current')) item.setAttribute('aria-current', String(active));
    });
    // The original image adapter retains its offer-controlled image, crop flags and caption.
    var image = gallery.querySelector('[data-gallery-main]');
    if (image && target.dataset.src) {
      image.src = target.dataset.src;
      if (target.dataset.srcset) image.srcset = target.dataset.srcset;
      image.classList.toggle('contain', target.dataset.contain === '1');
      image.classList.toggle('is-whole', target.dataset.whole === '1');
      image.classList.toggle('is-lift', target.dataset.lift === '1');
      if (!imageAlt && target.dataset.kpThumb && target.querySelector('img')) imageAlt = target.querySelector('img').alt;
      if (imageAlt) image.alt = imageAlt;
      image.parentNode.classList.toggle('has-whole', target.dataset.whole === '1');
    }
    // Native video/model adapters use the same shell and selection, pausing hidden videos.
    ['[data-kp-panel]', '[data-kp-mobile-media]'].forEach(function (selector) {
      gallery.querySelectorAll(selector).forEach(function (panel) {
        panel.hidden = (panel.dataset.kpPanel || panel.dataset.kpMobileMedia) !== id;
        if (panel.hidden) panel.querySelectorAll('video').forEach(function (video) { video.pause(); });
      });
    });
    var number = 'Fig. ' + String(items.indexOf(target) + 1).padStart(2, '0');
    var figure = gallery.querySelector('[data-kp-figure]');
    if (figure) figure.textContent = number;
    var legacyFigure = gallery.querySelector('#gfig');
    if (legacyFigure && target.dataset.cap) {
      var label = document.createElement('span'); label.className = 'k-fig__n'; label.textContent = number;
      legacyFigure.replaceChildren(label, document.createTextNode(' ' + target.dataset.cap));
    }
    if (scroll && window.matchMedia('(max-width:920px)').matches) {
      var track = gallery.querySelector('.gallery__thumbs');
      // The original offer switch uses an immediate scroll. Native media respects reduced motion.
      var behavior = !id || window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth';
      window.requestAnimationFrame(function () { track.scrollTo({ left: target.offsetLeft - (id ? track.offsetLeft : 0), behavior: behavior }); });
    }
  }
  function init(gallery) {
    if (gallery.dataset.galleryInitialized) return;
    gallery.dataset.galleryInitialized = 'true';
    var items = thumbs(gallery), track = gallery.querySelector('.gallery__thumbs');
    items.forEach(function (item, index) {
      item.addEventListener('click', function () { select(gallery, item, !!item.dataset.kpThumb); });
      item.addEventListener('keydown', function (event) {
        if (item.dataset.kpThumb && (event.key === 'Enter' || event.key === ' ')) { event.preventDefault(); select(gallery, item, true); return; }
        var next = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = Math.min(index + 1, items.length - 1);
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = Math.max(index - 1, 0);
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = items.length - 1;
        else return;
        event.preventDefault(); select(gallery, items[next], true); items[next].focus({ preventScroll: true });
      });
    });
    if (track && gallery.hasAttribute('data-kp-gallery')) track.addEventListener('scroll', function () {
      if (!window.matchMedia('(max-width:920px)').matches || !items.length) return;
      var nearest = items.reduce(function (best, item) {
        return Math.abs(item.offsetLeft - track.offsetLeft - track.scrollLeft) < Math.abs(best.offsetLeft - track.offsetLeft - track.scrollLeft) ? item : best;
      });
      select(gallery, nearest, false);
    }, { passive: true });
  }
  window.KorenaProductGallery = { select: select, init: init };
  function boot(scope) { scope.querySelectorAll('[data-korena-gallery]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }); else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
}());
